import React from 'react'

import { PortalProvider } from '../dom/Portal'

export function ReactProvider({ children }: React.PropsWithChildren<object>) {
  return <PortalProvider>{children}</PortalProvider>
}
